import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.ForceTbiAndInvoice.title',
    defaultMessage: 'Force TBI',
  },
  confirm: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.ForceTbiAndInvoice.confirm',
    defaultMessage: 'This will reset invoice references and invoice ALL eligible tasks on order again. Do you want to proceed?',
  },
  info: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.ForceTbiAndInvoice.info',
    defaultMessage: 'Creating invoice. Please wait.',
  },
  success: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.ForceTbiAndInvoice.success',
    defaultMessage: 'New invoice successfully created',
  },
  error: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.ForceTbiAndInvoice.error',
    defaultMessage: 'Force invoicing failed\n{errors}',
  }
})
